var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M86.4 8.524c-3.175 1.446-6.593 2.423-10.178 2.86 3.66-2.247 6.47-5.81 7.795-10.052-3.428 2.08-7.216 3.593-11.263 4.405C69.528 2.205 64.918 0 59.816 0c-9.783 0-17.72 8.14-17.72 18.176 0 1.425.152 2.808.456 4.14-14.732-.76-27.79-7.988-36.54-18.997-1.526 2.694-2.4 5.82-2.4 9.148 0 6.303 3.13 11.867 7.886 15.128-2.9-.088-5.64-.915-8.033-2.267v.224c0 8.8 6.11 16.158 14.225 17.822-1.486.426-3.053.64-4.67.64a17.22 17.22 0 0 1-3.337-.322c2.257 7.218 8.8 12.476 16.558 12.616C20.18 61.183 12.53 64.1 4.23 64.1c-1.43 0-2.845-.083-4.23-.25C7.845 68.99 17.166 72 27.172 72c32.61 0 50.434-27.692 50.434-51.713 0-.8-.015-1.58-.046-2.356A36.38 36.38 0 0 0 86.4 8.524","transform":"matrix(.999848 .017452 -.017452 .999848 1.256574 -.731932)","fill":"#5e5e5e","fillRule":"evenodd"}));
}

Twitter.defaultProps = {"width":"88","height":"72"};

module.exports = Twitter;

Twitter.default = Twitter;
